import { render, staticRenderFns } from "./bamap.vue?vue&type=template&id=452a21c0"
import script from "./bamap.vue?vue&type=script&lang=js"
export * from "./bamap.vue?vue&type=script&lang=js"
import style0 from "./bamap.vue?vue&type=style&index=0&id=452a21c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports